import React from 'react';

import { SupportedProcessors } from '../../../constants';

import { CreditCardFormProps } from './creditCard.types';
import { CreditCardForm } from './CreditCardForm';
import { TokenexCardForm } from './TokenexCardForm';

export const GenericCardForm = React.forwardRef((
  props: CreditCardFormProps,
  ref,
) => (props.processor === SupportedProcessors.DLOCAL
  ? <TokenexCardForm {...props} ref={ref} />
  : <CreditCardForm {...props} ref={ref} />));
